import { List, Map } from 'immutable';

import { getAIOperation, getProductOperation } from '../../ai';
import { getSize } from '../../../iterable/getSize';

import { ATTRIBUTE_TO_DESTINATION } from '../../../../constants/ai';
import { EMPTY, VELA } from '../../../../constants';
import { OPERATIONS } from '../../../../constants/bulkEdit';
import { ATTRIBUTE } from '../../../../constants/attributes';

export function aiGenerated({ attribute, channel, preview, state }) {
  const products = state.get('products');
  const ai = preview.getIn([attribute, 'ai']);

  function reduceProductIds(result, productId) {
    function addProductId(operationProducts) {
      return operationProducts.push(productId);
    }

    if (ai.hasIn([productId, 'generated'])) {
      const operation = getProductOperation({ ai: ai.get(productId), attribute, channel, productId });
      result.productOperations = result.productOperations.push(operation);
    } else {
      result.aiOpertation = result.aiOpertation.update('products', addProductId);
    }

    return result;
  }

  const { aiOpertation, productOperations } = products
    .get('selected')
    .reduce(
      reduceProductIds,
      {
        aiOpertation: getAIOperation({
          channel,
          products: EMPTY.LIST,
          value: {
            destination: ATTRIBUTE_TO_DESTINATION[attribute] || attribute,
            instructions: ai.getIn([VELA, 'instructions']),
            operation: ai.getIn([VELA, 'operation']),
          },
        }),
        productOperations: EMPTY.LIST,
      }
    );

  return {
    payload: getSize(aiOpertation.get('products')) > 0
      ? productOperations.unshift(aiOpertation)
      : productOperations,
  };
}

export function aiGeneratedAltText({ channel, preview, state }) {
  const page = state.getIn(['page', 'currentPage']);
  const products = state.get('products');

  function reduceProductIds(result, productId) {
    function reducePhotoIndexes(payload, value, index) {
      return payload.push(
        Map({
          type: OPERATIONS[channel].PHOTOS.UPDATE,
          products: List([productId]),
          value: Map({
            attributes: Map({ alt_text: value }),
            index,
          }),
        })
      );
    }

    if (!products.hasIn(['selected', productId])) {
      if (result.preview.hasIn([ATTRIBUTE.PHOTOS, 'ai', productId, 'generated'])) {
        result.preview = result.preview.deleteIn([ATTRIBUTE.PHOTOS, 'ai', productId]);
      }
    } else if (result.preview.hasIn([ATTRIBUTE.PHOTOS, 'ai', productId, 'generated'])) {
      result.edited = result.edited.add(productId);
      result.payload = result.preview
        .getIn([ATTRIBUTE.PHOTOS, 'ai', productId, 'generated'])
        .reduce(reducePhotoIndexes, result.payload);

      result.preview = result.preview.deleteIn([ATTRIBUTE.PHOTOS, 'ai', productId]);
    }

    if (
      result.preview.hasIn([ATTRIBUTE.PHOTOS, 'ai']) &&
      getSize(result.preview.getIn([ATTRIBUTE.PHOTOS, 'ai']).delete(VELA)) === 0
    ) {
      result.preview = result.preview.deleteIn([ATTRIBUTE.PHOTOS, 'ai']);
    }

    if (
      result.preview.hasIn([ATTRIBUTE.PHOTOS, 'products', 'processing']) &&
      getSize(result.preview.getIn([ATTRIBUTE.PHOTOS, 'products', 'processing'])) === 0
    ) {
      result.preview = result.preview.deleteIn([ATTRIBUTE.PHOTOS, 'products', 'processing']);
    }

    if (
      result.preview.hasIn([ATTRIBUTE.PHOTOS, 'products', 'processed']) &&
      getSize(result.preview.getIn([ATTRIBUTE.PHOTOS, 'products', 'processed'])) === 0
    ) {
      result.preview = result.preview.deleteIn([ATTRIBUTE.PHOTOS, 'products', 'processed']);
    }

    if (
      result.preview.hasIn([ATTRIBUTE.PHOTOS, 'products']) &&
      getSize(result.preview.getIn([ATTRIBUTE.PHOTOS, 'products'])) === 0
    ) {
      result.preview = result.preview.deleteIn([ATTRIBUTE.PHOTOS, 'products']);
    }

    if (!result.preview.hasIn([ATTRIBUTE.PHOTOS, 'ai']) && !result.preview.hasIn([ATTRIBUTE.PHOTOS, 'products'])) {
      result.preview = EMPTY.MAP;
    }

    return result;
  }

  return products
    .get('ids')
    .reduce(
      reduceProductIds,
      {
        edited: EMPTY.SET,
        payload: EMPTY.LIST,
        preview: preview
          .deleteIn([ATTRIBUTE.PHOTOS, 'products', 'processed', page])
          .deleteIn([ATTRIBUTE.PHOTOS, 'products', 'processing', page]),
      },
    );
}
